import React from 'react';
import { IdsIconsDefinition } from '@ids/react-icon';
import { useStateSelector } from 'store';
import { Render } from 'types';
import { WorkshopField } from './shared/WorkshopField';
import { WorkshopSection } from './shared/WorkshopSection';

export function WorkshopContactPerson(): Render {
  const editing = useStateSelector((state) => state.workshop.editing);

  const Field = WorkshopField(editing);

  const iconProps = { group: 'ui', size: 24, icon: 'send-message' } as IdsIconsDefinition;

  return (
    <WorkshopSection title='Contact' icon={iconProps} contentClass='flex-row' anchorTag='contact'>
      <Field property='contactPerson.name' />
      <Field property='contactPerson.email' label='E-mail' />
      <Field property='contactPerson.mobileNumber' />
      <Field property='contactPerson.phoneNumber' />
    </WorkshopSection>
  );
}
